<template>
  <v-dialog
    v-model="isOpen"
    @keydown.esc="dialogClose"
    persistent
    content-class="large"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Version history</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-spacer></v-spacer>
          <div class="d-flex justify-end align-center no-margin-right">
            <div class="text-label m-r-10">
              {{
                search.showActive
                  ? 'Show only versions with comment'
                  : 'Show all versions'
              }}
            </div>
            <v-switch
              v-model="search.showActive"
              inset
              dense
              x-small
              hide-details
            ></v-switch>
          </div>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-data-table
                :loading="loading"
                :headers="headers"
                :items="flowLogs"
                :page.sync="search.page"
                :sort-by.sync="search.sortBy"
                :sort-desc.sync="search.sortDesc"
                :items-per-page="9999"
                item-key="_id"
                hide-default-footer
                fixed-header
                must-sort
                class="elevation-1"
              >
                <template v-slot:item="props">
                  <tr
                    :id="`field${props.index}`"
                    class="cursor-pointer"
                    @mouseover="hoverRow(flowLogs.indexOf(props.item))"
                    @mouseleave="leaveRow"
                  >
                    <td>{{ props.item.created_at | datetime }}</td>
                    <td>
                      {{ props.item.email }}
                    </td>
                    <td
                      v-on:dblclick="
                        editValueClick(flowLogs.indexOf(props.item))
                      "
                    >
                      <div
                        v-if="editedRow._id !== props.item._id"
                        class="word-break-break-all cursor-pointer"
                      >
                        {{ props.item.description }}
                      </div>
                      <div v-else>
                        <v-text-field
                          :ref="`inputEditRowValue-${props.item._id}`"
                          v-model="editedRow.value"
                          maxlength="500"
                          hide-details
                          @blur="editValueBlur"
                          @keyup.esc="editValueBlur"
                          @keyup.enter="editValueEnter"
                        ></v-text-field>
                      </div>
                    </td>
                    <td class="text-center">
                      <a
                        v-if="hoveredRow === props.item._id"
                        href="javascript:void(0);"
                        class="text-link"
                        @click="confirmRestore(flowLogs.indexOf(props.item))"
                      >
                        Restore
                      </a>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>

          <v-row
            v-if="flowLogs.length > 0"
            class="fix-height"
            align="center"
            justify="end"
          >
            <v-col
              class="d-flex align-center padding0 pagination"
              cols="auto"
              sm="auto"
              md="auto"
              lg="auto"
            >
              Page size
              <v-select
                id="perpage"
                class="select-item text-center m-l-10 m-r-10"
                v-model="search.limit"
                :items="$itemspage"
                item-text="title"
                item-value="value"
                no-label
                hide-details
                dense
                @input="search.limit = parseInt($event, 10)"
              ></v-select>

              Showing {{ (search.page - 1) * search.limit + 1 }} -
              {{ (search.page - 1) * search.limit + flowLogs.length }} of
              {{ total | decimalFormat }}

              <v-pagination
                id="pagination"
                v-model="search.page"
                :length="totalPage"
                :total-visible="totalVisible"
                @input="next"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn id="btn-close" class="btn-secondary" @click="dialogClose">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import apiFlowLog from '@/apis/flow_log'

export default {
  name: 'DialogViewLogFlow',
  props: {
    isOpen: Boolean,
    flowId: String
  },
  data() {
    return {
      loading: false,
      totalPage: 1,
      totalVisible: 7,
      total: 0,
      search: {
        showActive: false,
        sortBy: ['created_at'],
        sortDesc: [true],
        page: 1,
        limit: 50
      },
      singleExpand: true,
      headers: [
        {
          text: 'Modified on',
          align: 'start',
          sortable: false,
          value: 'created_at',
          width: '180px'
        },
        { text: 'By', value: 'description', sortable: false, width: '220px' },
        { text: 'Comment', value: 'result', sortable: false },
        { text: '', value: 'action', sortable: false, width: '80px' }
      ],
      flowLogs: [],
      hoveredRow: '',
      editedRow: {
        _id: '',
        value: ''
      }
    }
  },
  created() {
    this.initial()

    for (const property in this.search) {
      this.$watch(
        `search.${property}`, //what you want to watch
        (newVal, oldVal) => {
          if (property !== 'sortBy') {
            this.getFlowLog(property)
          }
        }
      )
    }
  },

  methods: {
    next(page) {
      this.index = -1
    },
    async initial() {
      await this.getFlowLog()
    },
    async getFlowLog(property) {
      try {
        if (!['sortBy', 'sortDesc', 'page'].includes(property))
          this.search.page = 1

        this.loading = true

        const getFlowLog = await apiFlowLog.listFlowLog(
          this.flowId,
          this.search
        )

        const { docs, totalPages, totalDocs } = getFlowLog.data
        this.totalPage = totalPages
        this.total = totalDocs

        this.flowLogs = docs

        setTimeout(() => {
          this.loading = false
        }, 500)
      } catch (error) {}
    },
    hoverRow(index) {
      const item = this.flowLogs[index]

      this.hoveredRow = item._id
    },
    leaveRow(index) {
      this.hoveredRow = ''
    },
    editValueClick(index) {
      const item = this.flowLogs[index]

      this.editedRow._id = item._id
      this.editedRow.value = item.description

      setTimeout(() => {
        this.$refs[`inputEditRowValue-${item._id}`].focus()
      }, 200)
    },
    async editValueEnter() {
      try {
        const getFlowLog = await apiFlowLog.updateFlowLog(this.editedRow._id, {
          description: this.editedRow.value
        })

        this.editedRow = {
          _id: '',
          value: ''
        }

        this.getFlowLog()
      } catch (error) {}
    },
    editValueBlur() {
      this.testSets = this.tmpTestSets
      this.editedRow = {
        _id: '',
        value: ''
      }
    },
    dialogClose() {
      this.$emit('dialogClose', null)
    },
    confirmRestore(index) {
      const item = this.flowLogs[index]
      this.$emit('confirmRestore', item)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-data-table__wrapper {
  height: calc(100vh - 350px);
}
.border-bottom-expanded {
  border-bottom: 1px solid #d0d3d6;
  margin: 0;
  padding: 0;
}

.no-margin-right {
  margin-right: -15px;
}
</style>
